import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";
import leaf from "../../Assets/Projects/leaf.png";
import emotion from "../../Assets/Projects/emotion.png";
import editor from "../../Assets/Projects/codeEditor.png";
import chatify from "../../Assets/Projects/chatify.png";
import suicide from "../../Assets/Projects/suicide.png";
import bitsOfCode from "../../Assets/Projects/blog.png";

function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Works </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few projects I've worked on recently.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={chatify}
              isBlog={false}
              title="Kausi Farming"
              description="App that suggest best crop to be cultivated in the terrace using open street Api's and other open data. "
              ghLink="https://github.com/bikalpasharma/kausifarming"
              demoLink="#"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={bitsOfCode}
              isBlog={false}
              title="BookXchange"
              description="Second hand book sharing app created with React JS and Django. Uses credit points for transaction."
              ghLink="https://github.com/bikalpasharma/bookxchange"
              demoLink="#"
            />
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={editor}
              isBlog={false}
              title="Other Sites"
              description="Other sites created using wordpress , bootstrap and other frameworks."
              ghLink="https://github.com/bikalpasharma/ListNotes/blob/master/websites.txt"
              demoLink="#"              
            />
          </Col>

          
        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
